import React from "react";
import { setSocialMediaType, useAppDispatch } from "@hypexone/uicore";
import { SocialMediaTypeEnum } from "../../../utils/types/userMenu.types";

interface SocialMediaButtonProps {
  handleButtonClick: () => void;
  iconSrc: string;
  buttonLabel: SocialMediaTypeEnum;
  bgClassName?: string;
  showLabel?: boolean;
  variant?: "default" | "header";
}

const SocialMediaButn: React.FC<SocialMediaButtonProps> = ({
  handleButtonClick,
  iconSrc,
  buttonLabel,
  bgClassName = "bg-[#243A48]",
  showLabel = true,
  variant = "default",
}) => {
  const dispatch = useAppDispatch();
  const isLightBg =
    bgClassName.includes("ebebeb") ||
    bgClassName.includes("bg-white") ||
    bgClassName.includes("bg-[#fff");
  const isHeader = variant === "header";

  return (
    <button
      onClick={() => {
        handleButtonClick();
        dispatch(setSocialMediaType(buttonLabel));
      }}
      className={`flex ${bgClassName} items-center justify-center capitalize transition-all duration-200 hover:brightness-95 ${
        isLightBg ? "text-black" : "text-white"
      } ${
        isHeader
          ? "h-7 w-7 shrink-0 rounded-md border border-white/15 bg-white p-0 shadow-none"
          : "h-8 w-auto min-w-0 rounded-lg border border-black/10 px-3.5 text-xs font-medium shadow-sm"
      }`}
    >
      <img
        src={iconSrc}
        alt="social-icon"
        className={`${isHeader ? "h-3.5 w-3.5" : "h-3.5 w-3.5"} ${showLabel ? "mr-1.5" : ""}`}
      />
      {showLabel && (
        <span className="capitalize leading-none">{buttonLabel?.toLowerCase()}</span>
      )}
    </button>
  );
};

export default SocialMediaButn;
